import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Games(props: StickerArtProps) {
  return (
    <StickerFrame background="#7c3aed" {...props}>
      <rect x="11" y="23" width="42" height="21" rx="10.5" fill="#ffffff" />
      <rect x="18" y="31.5" width="11" height="4" rx="1" fill="#1f2937" />
      <rect x="21.5" y="28" width="4" height="11" rx="1" fill="#1f2937" />
      <circle cx="41" cy="30.5" r="2.8" fill="#ef4444" />
      <circle cx="45.5" cy="36.5" r="2.8" fill="#2563eb" />
    </StickerFrame>
  );
}
